import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // URL에서 언어 코드 추출하여 초기값 설정
  const getInitialLanguage = () => {
    const pathSegments = window.location.pathname.split('/');
    const urlLanguage = pathSegments[1];
    return (urlLanguage === 'ko' || urlLanguage === 'en') ? urlLanguage : 'ko';
  };

  const [language, setLanguage] = useState(getInitialLanguage);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ko' ? 'en' : 'ko');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
